import { get, isEmpty } from "lodash";
import {
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../components/ui";
import { Brand } from "../../../../types";
export type FilterProps = {
  label: string;
  placeholder?: string;
  key: string;
  name: string;
  options: Array<{
    value: string;
    count: number;
  }>;
  values: Array<string>;
  onFilterChange: (filter: string, value: Array<string>) => void;
};

export type FiltersProps = {
  filters: Array<FilterProps>;
  value: string;
  brands: Brand[];
  modeles: string[];
  children: React.ReactNode;
  onFilterChange: (filter: string, value: string) => void;
  onReset: () => void;
};

const Filter: React.FC<FilterProps> = (props) => {
  const { name, label, placeholder, options, value, onFilterChange } = props;

  const onValueChange = (value: string) => {
    onFilterChange(name, value);
  };

  if (isEmpty(options)) return null;

  return (
    <Select onValueChange={onValueChange} value={value}>
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {placeholder && (
          <SelectItem key="all" value="all">
            {placeholder}
          </SelectItem>
        )}
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.value}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

const Filters: React.FC<FiltersProps> = (props) => {
  const { values, brands, modeles, onFilterChange, onReset, children } = props;

  return (
    <div className="flex flex-col lg:flex-row gap-2">
      {children}
      <Filter
        label="Marque"
        key="brand"
        name="brand"
        options={brands.map((brand) => ({
          value: brand.title,
          label: brand.title,
        }))}
        placeholder="Toutes les marques"
        value={get(values, "brand", undefined)}
        onFilterChange={onFilterChange}
      />
      {modeles && modeles.length > 0 && (
        <Filter
          label="Modèle"
          key="model"
          name="model"
          options={modeles.map((modele) => ({
            value: modele,
            label: modele,
          }))}
          placeholder="Tous les modèles"
          value={get(values, "model", undefined)}
          onFilterChange={onFilterChange}
        />
      )}
      {!isEmpty(values) && (
        <Button onClick={onReset} variant="link">
          Réinitialiser les filtres
        </Button>
      )}
    </div>
  );
};

export default Filters;
